<template>
  <div class="c-button-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less">
.c-button-group {
  font-size: 0;
  .gxxt-button {
    border-radius: 0;
    margin-left: -1px;
  }
  .gxxt-button:first-child {
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
  }
  .gxxt-button:last-child {
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }
}
</style>